// import { useContext } from "react";
import { 
	// AboutUsContacts, 
	AboutUsContainer, AboutUsImg, AboutUsInfo, AboutUsText, AboutUsWrapper, SmokeEffect } from "./about-us.styles";

import amortizatoareLogo from '../../assets/img/about-us.jpg';
// import Button from "../button/button.component";
// import externalLink from '../../assets/icons/icon-external-link-blue.svg'
// import smokeEffect from '../../assets/img/smoke-left-min.png';
import mesrLogo from '../../assets/img/about-us-bg.png';
// import { Link } from "react-scroll";
// import { LanguageContext } from "../../contexts/language.context";

import "./styles.scss"


const AboutUs =({props})=>{
	return(
		<AboutUsWrapper className="about-us">
			<SmokeEffect>
				<img src={mesrLogo} alt="" style={{ maxWidth: 450 }} className="mers"/>
			</SmokeEffect>
			<AboutUsContainer>
				<AboutUsImg>
					<img src={amortizatoareLogo} alt="" />
				</AboutUsImg>
				<AboutUsInfo>
					<AboutUsText>
						<h2 id="about-us">{props[1]}</h2>
						<p>{props[2]}</p>
						<p>{props[9]}</p>
						<p>{props[10]}</p>

						<h2 id="about-us">{props.listTitle}</h2>
						<ul className="aboutUsBenefitsList">
							<li>{props.listItem1}</li>
							<li>{props.listItem2}</li>
							<li>{props.listItem3}</li>
							<li>{props.listItem4}</li>
							<li>{props.listItem5}</li>
							<li>{props.listItem6}</li>
						</ul>
						{/* <h2 id="products">{props[3]}</h2>
						<p>{props[4]}<span> {props[4.1]} </span> {props[4.2]}</p>
						<h2>{props[5]}</h2>
						<p>{props[6]}</p> */}
					</AboutUsText>
					{/* <AboutUsContacts>
						<Link to="form" spy={true} smooth={true} offset={0} duration={500}>
							<Button children={props[7]}/>
						</Link>
						<a rel="noreferrer" target='_blank' href="https://docs.google.com/document/d/1YJpYhOyVK7dvbNsJK8R1sQcQOcPYZSyBv4UecnTto-k/edit">
							<button className="purpleBtn">
								<span>{props[8]}</span>
								<img src={externalLink} alt=""/>
							</button>
						</a>
					</AboutUsContacts> */}
				</AboutUsInfo>
			</AboutUsContainer>
			
		</AboutUsWrapper>
	)
}

export default AboutUs;